import React, { useState } from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import Card from "./Card";
import { toast } from "react-toastify";

const CartPayment = ({ setIsPaymentTrue }) => {
  const [value, setValue] = useState("");
  const [isPaymentPopUpConfirmed, setisPaymentPopUpConfirmed] = useState(false);
  const handleChange = (e) => {
    setValue(e.target.value);
  };

  const toastMsg =
    "Please choose any payment option first, then you are allowed to go next step!";
  const toastStyle = { position: "top-center", autoClose: 5000 };

  return (
    <section className="fixed w-[100vw] h-[100vh] bg-[rgba(0,0,0,0.8)] top-0 left-0 flex items-center justify-center p-5">
      <article
        className={` h-auto md:w-[500px] w-[100%] mx-6 bg-[#ffffff] p-3 ${
          value !== "" && isPaymentPopUpConfirmed && "popupHidden"
        }`}
      >
        <FormControl sx={{ width: "100%", textAlign: "center" }}>
          <FormLabel
            id="demo-row-radio-buttons-group-label"
            sx={{ color: "black", fontWeight: "bold", letterSpacing: "0.1rem" }}
            className="bal-pay-title"
          >
            Choose Payment Options
          </FormLabel>
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            value={value}
            onChange={handleChange}
          >
            <div className="flex justify-between md:justify-center items-center flex-wrap w-[100%] sm:px-4 card-Option-select">
              <div className="border-2  text-center w-20 m-1">
                <FormLabel>Master</FormLabel>
                <FormControlLabel
                  value="master"
                  sx={{ marginLeft: "14px" }}
                  control={<Radio />}
                />
              </div>
              <div className=" border-2  text-center w-20 m-1">
                <FormLabel className="block">Visa</FormLabel>
                <FormControlLabel
                  sx={{ marginLeft: "16px" }}
                  value="visa"
                  control={<Radio />}
                />
              </div>
              <div className=" border-2  text-center w-20 m-1">
                <FormLabel className="block">Credit</FormLabel>
                <FormControlLabel
                  sx={{ marginLeft: "16px" }}
                  value="credit"
                  control={<Radio />}
                />
              </div>
              <div className=" border-2  text-center w-20 m-1">
                <FormLabel className="block">Debit</FormLabel>
                <FormControlLabel
                  sx={{ marginLeft: "16px" }}
                  value="debit"
                  control={<Radio />}
                />
              </div>
            </div>
          </RadioGroup>
        </FormControl>
        <div className="px-2 text-black font-extrabold">
          <button
            onClick={() => {
              value !== ""
                ? setisPaymentPopUpConfirmed(true)
                : toast.warn(toastMsg, toastStyle);
            }}
            className=" w-[99%] border-2 my-2 mx-auto border-[black] rounded-md tracking-widest py-1"
          >
            Confirm
          </button>
          <button
            onClick={() => setIsPaymentTrue(false)}
            className=" w-[99%] border-2 my-2 mx-auto border-[black] rounded-md tracking-widest py-1"
          >
            Cancel
          </button>
        </div>
      </article>
      {isPaymentPopUpConfirmed && value !== "" && (
        <Card
          value={value}
          setIsPaymentTrue={setIsPaymentTrue}
          setisPaymentPopUpConfirmed={setisPaymentPopUpConfirmed}
        />
      )}
    </section>
  );
};

export default CartPayment;
